<template>
  <div>
     
    <v-row
      class="pa-4 pr-1">
      <v-col 
        cols="12"
        class="py-0">
        <v-card 
          flat
          min-height="calc(100vh - 245px)">

          <v-card-text
            v-if="Object.keys(detail).length < 1" 
            class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
            <div class="text-center">
              <div class="mb-2 title">
                Mohon Tunggu...
              </div>
              <v-progress-circular
                indeterminate
              ></v-progress-circular>
            </div>
          </v-card-text>

          <v-card-text v-if="Object.keys(detail).length > 0">
            <v-row>

                        <v-col
                          cols="12"
                          md="6" class="pt-0">
                          <div>
                            <div >
                              <!-- <span class="red--text">*</span> -->
                              Nama
                            </div>
                            <div class="fs-15 label-input">
                              {{ detail.name }}
                            </div>
                          </div>

                          <div>
                            <div >
                              <!-- <span class="red--text">*</span> -->
                              Alias
                            </div>
                            <div class="fs-15 label-input">
                              {{ detail.alias === '' ? '-' : detail.alias }}
                            </div>
                          </div>
                          
                          <div>
                            <div 
                              class="">
                              <!-- <span class="red--text">*</span> -->
                              Kategori
                            </div>
                            <div class="fs-15 label-input">
                              {{ form.category_product_name_1 === '' ? '-' : form.category_product_name_1 }}
                            </div>
                          </div>


                        </v-col>
                        
                        <v-col
                        cols="12"
                        md="6" class="pt-0">

                          <div>
                            <div >
                              <!-- <span class="red--text">*</span> -->
                              Kode
                            </div>
                            <div class="fs-15 label-input">
                              {{ detail.code === '' ? '-' : detail.code }}
                            </div>
                          </div>

                          <div>
                            <div >
                              <!-- <span class="red--text">*</span> -->
                              Nomor SKU
                            </div>
                            <div class="fs-15 label-input">
                              {{ detail.sku_number === '' ? '-' : detail.sku_number }}
                            </div>
                          </div>
                          
                          <!-- <div>
                            <div 
                              class="">
                              Kategori Kedua
                            </div>
                            <div class="fs-15 label-input">
                              {{ form.category_product_name_2 }}
                            </div>
                          </div> -->
                          
                        </v-col>
                        <v-col cols="12">
                          <div>
                            <div 
                              class="">
                              <!-- <span class="red--text">*</span> -->
                              Deskripsi
                            </div>
                            <div class="fs-15 label-input">
                              {{ detail.desc === '' ? '-' : detail.desc }}
                            </div>
                          </div>

                          <div>
                            <div>
                              Gambar Produk
                            </div>
                            <v-card 
                              flat
                              width="250"
                              height="250"
                              class="d-flex align-center justify-center mt-2"
                              style="border-radius: 15px;
                                    border: 2px solid #eaeaea; 
                                    border-style: dashed;">
                              <v-img
                                contain
                                width="250"
                                height="250"
                                :src="detail.image_url" 
                                :alt="detail.image_url"
                                class="text-center d-flex align-center">
                              </v-img>
                            </v-card>
                          </div>

                        </v-col>
                      </v-row>

            <div v-if="message.error.length > 0"
              class="text-center my-4 d-flex align-center">
              <div
                class="error--text">
                <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>


<script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      props: {
        detail: {
          type: Object,
          default: {}
        }
      },
      data () {
        return {
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          menu: false,
          modal: false,
          menu2: false,
          
          zoomed: false,
          zoomedTtd: false,
          imageAspectRatio: 1,
          imageAspectRatioTtd: 1,

          form: {
          id: '',
          code: '',
          sku_number: '',
          name: '',
          alias: '',
          category_product_id_1: '',
          category_product_id_2: '',
          category_product_name_1: '',
          category_product_name_2: '',
          desc: '',
        },
        category: [],
        category_pertama: [],

        category_kedua: [],
        
  
          process: {
            form: false,
          },
          
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {

      },
      watch: {
        
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      mounted () {
        this.fetchCategoru()
      },
      methods: {
        async fetchCategoru() {

         let params = {
          limit: 10000000000000
        }

        await get(`admin/category_product/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.category = res.results.data
            this.category_pertama = res.results.data

            this.category_kedua = res.results.data

            const results = this.category.filter(({ id: id1 }) => this.detail.category_product_id_1 !== id1);
            
            this.category_kedua = results
            const results_name = this.category.filter(({ id: id1 }) => this.detail.category_product_id_1 === id1);
            this.form.category_product_name_1 = results_name[0].name
            const results_name_2 = this.category.filter(({ id: id1 }) => this.detail.category_product_id_2 === id1);
            this.form.category_product_name_2 = results_name_2[0].name
          }
        })
      },
        onImageLoad(e) {
          const img = e.target
          this.imageAspectRatio = img.naturalWidth / img.naturalHeight
        },
        onImageLoadAkta(e) {
          const img = e.target
          this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
        },
      }
    }
  </script>